/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-magic-numbers */
import { useLazyQuery, useMutation } from '@apollo/client'
import { API_V2 } from 'constants/apollo'
import React, { useEffect, useMemo, useState } from 'react'
import {
  GET_NEW_RELEASES_AND_SALES_BOOKS,
  UPDATE_BOOK_ADMIN_HOT,
} from 'services/book/graphql'
import {
  Box,
  Flex,
  Icon,
  IconButton,
  Input,
  Spinner,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tooltip,
  Tr,
  useDisclosure,
} from '@chakra-ui/react'
import Pagination from 'components/UI/Pagination'
import Filters from './Filters'
import ApplyBooleanModal from './ApplyBooleanModal'
import { FaCheck, FaTrashAlt } from 'react-icons/fa'
import { FILTERS, ORDERING } from './Filters/constants'
import SearchBookModal from './SearchBookModal'

const ITEMS = 10

const ReleasesAndSales = ({ showButtons }) => {
  const [isReleased, setIsReleased] = useState('omitted')
  const [isSales, setIsSales] = useState('omitted')
  const [isHot, setIsHot] = useState('omitted')
  const [isListenable, setIsListenable] = useState('omitted')
  const [isDeleted, setIsDeleted] = useState('omitted')
  const [books, setBooks] = useState([])
  const [page, setPage] = useState(0)
  const [total, setTotal] = useState(0)
  const [status, setStatus] = useState('all')
  const [releaseFrom, setReleaseFrom] = useState('')
  const [releaseTo, setReleaseTo] = useState('')
  const [fromSaleDate, setFromSaleDate] = useState('')
  const [toSaleDate, setToSaleDate] = useState('')
  const [applyData, setApplyData] = useState(null)
  const [releaseDateActive, setReleaseDateActive] = useState('')
  const [releaseDate, setReleaseDate] = useState('')
  const [saleDateActive, setSaleDateActive] = useState('')
  const [saleDate, setSaleDate] = useState('')
  const [saleValueActive, setSaleValueActive] = useState('')
  const [saleValue, setSaleValue] = useState('')
  const [ordering, setOrdering] = useState(ORDERING.ASC)
  const [sortBy, setSortBy] = useState(FILTERS.TITLE)
  const [perPage, setPerPage] = useState(ITEMS)

  const {
    isOpen: isApplyOpen,
    onOpen: onApplyOpen,
    onClose: onApplyClose,
  } = useDisclosure()
  const {
    isOpen: isSearchOpen,
    onOpen: onSearchOpen,
    onClose: onSearchClose,
  } = useDisclosure()

  const [getNewReleasesAndSalesBooks, { loading }] = useLazyQuery(
    GET_NEW_RELEASES_AND_SALES_BOOKS,
    {
      fetchPolicy: 'network-only',
      context: {
        clientName: API_V2,
      },
    },
  )

  const [updateStory, { loading: updateStoryLoading }] = useMutation(
    UPDATE_BOOK_ADMIN_HOT,
    {
      context: {
        clientName: API_V2,
      },
    },
  )

  const handleOrderingChange = e => {
    setOrdering(e.target.value)
  }

  const handlePerPageChange = e => {
    setPerPage(Number(e.target.value))
  }

  const handleSortByChange = e => {
    setSortBy(e.target.value)
  }

  const handleReleaseDateChange = e => {
    setReleaseDate(e.target.value)
  }
  const handleSaleDateChange = e => {
    setSaleDate(e.target.value)
  }
  const handleSaleValueChange = e => {
    setSaleValue(Number(e.target.value))
  }
  const handleFromSaleDateChange = e => {
    setFromSaleDate(e.target.value)
  }
  const handleToSaleDateChange = e => {
    setToSaleDate(e.target.value)
  }

  const handleReleaseFromChange = e => {
    setReleaseFrom(e.target.value)
  }
  const handleReleaseToChange = e => {
    setReleaseTo(e.target.value)
  }

  const handleStatusChange = value => {
    setStatus(value)
    setBooks([])
    setPage(0)
  }

  const handleDeletedChange = value => {
    setIsDeleted(value)
    setBooks([])
    setPage(0)
  }

  const handleReleasedChange = value => {
    setIsReleased(value)
    setBooks([])
    setPage(0)
  }
  const handleSalesChange = value => {
    setIsSales(value)
    setBooks([])
    setPage(0)
  }

  const handleHotChange = value => {
    setIsHot(value)
    setBooks([])
    setPage(0)
  }

  const handleListenableChange = value => {
    setIsListenable(value)
    setBooks([])
    setPage(0)
  }

  const changePage = step => {
    setPage(curr => curr + step)
  }

  const shouldShowPagination = useMemo(() => {
    return total > perPage
  }, [total, perPage])

  const isLoading = loading || updateStoryLoading

  const handleUpdateStory = async (bookId, params) => {
    try {
      const { data } = await updateStory({
        variables: { book: { id: bookId }, params },
      })

      if (data.book.id === bookId) {
        setBooks(prevBooks =>
          prevBooks.map(book => (book.id === bookId ? data.book : book)),
        )
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  const fetchBooks = async () => {
    const filter = {}
    const order = { field: sortBy, value: ordering }

    if (isReleased !== 'omitted') {
      filter.isReleased = isReleased === 'yes'
    }

    if (isDeleted !== 'omitted') {
      filter.deleted = isDeleted === 'yes'
    }

    if (isSales !== 'omitted') {
      filter.isSale = isSales === 'yes'
    }

    if (isHot !== 'omitted') {
      filter.isHot = isHot === 'yes'
    }

    if (isListenable !== 'omitted') {
      filter.isListenable = isListenable === 'yes'
    }

    if (status !== 'all') {
      filter.status = status
    }

    if (releaseFrom) {
      filter.fromReleaseDate = releaseFrom
    }

    if (releaseTo) {
      filter.toReleaseDate = releaseTo
    }

    if (fromSaleDate) {
      filter.fromSaleDate = fromSaleDate
    }

    if (toSaleDate) {
      filter.toSaleDate = toSaleDate
    }

    try {
      const { data } = await getNewReleasesAndSalesBooks({
        variables: {
          filter,
          pagination: {
            offset: 0,
            count: perPage,
          },
          order: [order],
        },
      })

      if (page > 0) {
        setPage(0)
      }
      setBooks(data.books.books)
      setTotal(data.books.pagination.total)
    } catch (error) {
      console.log('error', error)
    }
  }

  const visibleBooks = useMemo(() => {
    return books.slice(page * perPage, (page + 1) * perPage)
  }, [books, page, perPage])

  const fetchMoreBooks = async () => {
    const filter = {}
    const order = { field: sortBy, value: ordering }

    if (isReleased !== 'omitted') {
      filter.isReleased = isReleased === 'yes'
    }

    if (isDeleted !== 'omitted') {
      filter.deleted = isDeleted === 'yes'
    }

    if (isSales !== 'omitted') {
      filter.isSale = isSales === 'yes'
    }

    if (isHot !== 'omitted') {
      filter.isHot = isHot === 'yes'
    }

    if (isListenable !== 'omitted') {
      filter.isListenable = isListenable === 'yes'
    }

    if (status !== 'all') {
      filter.status = status
    }

    try {
      const { data } = await getNewReleasesAndSalesBooks({
        variables: {
          filter,
          pagination: {
            offset: page * perPage,
            count: perPage,
          },
          order: [order],
        },
      })
      setBooks(prevBooks => [...prevBooks, ...data.books.books])
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    if (page > 0 && total >= perPage * (page + 1)) {
      fetchMoreBooks()
    }
  }, [page])

  useEffect(() => {
    fetchBooks()
  }, [
    isReleased,
    isSales,
    isHot,
    isListenable,
    isDeleted,
    status,
    releaseFrom,
    releaseTo,
    fromSaleDate,
    toSaleDate,
    ordering,
    sortBy,
    perPage,
  ])

  return (
    <Flex
      position='relative'
      w='100%'
      direction='column'
      gap='6px'
      h={`calc(100vh - 132px${showButtons ? ' - 120px)' : ' - 33px)'}`}
      maxH={`calc(100vh - 132px${showButtons ? ' - 120px)' : ' - 33px)'}`}
    >
      {isLoading && (
        <Flex
          position='absolute'
          top='0'
          left='0'
          w='100%'
          h='100%'
          justify='center'
          align='center'
        >
          <Spinner size='xl' color='purple.500' />
        </Flex>
      )}

      <Filters
        isReleased={isReleased}
        isSales={isSales}
        isHot={isHot}
        isListenable={isListenable}
        isDeleted={isDeleted}
        status={status}
        handleStatusChange={handleStatusChange}
        handleReleasedChange={handleReleasedChange}
        handleSalesChange={handleSalesChange}
        handleHotChange={handleHotChange}
        handleListenableChange={handleListenableChange}
        handleDeletedChange={handleDeletedChange}
        handleReleaseFromChange={handleReleaseFromChange}
        handleReleaseToChange={handleReleaseToChange}
        releaseFrom={releaseFrom}
        releaseTo={releaseTo}
        handleFromSaleDateChange={handleFromSaleDateChange}
        handleToSaleDateChange={handleToSaleDateChange}
        fromSaleDate={fromSaleDate}
        toSaleDate={toSaleDate}
        ordering={ordering}
        handleOrderingChange={handleOrderingChange}
        sortBy={sortBy}
        handleSortByChange={handleSortByChange}
        handlePerPageChange={handlePerPageChange}
        perPage={perPage}
        onSearchOpen={onSearchOpen}
      />

      <Flex
        w='100%'
        mt={6}
        borderRadius='lg'
        boxShadow='lg'
        overflowX='auto'
        bg='white'
        p={4}
      >
        <Table flex={1}>
          <Thead bg='purple.50'>
            <Tr>
              <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                Title
              </Th>
              <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                Slug
              </Th>
              <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                Release Date
              </Th>
              <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                Is Released
              </Th>
              <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                Sale Date
              </Th>
              <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                Sale Value
              </Th>
              <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                Is Hot
              </Th>
              <Th fontWeight='bold' color='purple.700' fontSize='md' py={3}>
                Is Listenable
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {visibleBooks.map(book => {
              const colorByStatus = book.deleted
                ? 'red.100'
                : book.status === 'APPROVED'
                ? 'green.100'
                : 'gray.100'

              return (
                <Tr
                  key={book.id}
                  _hover={{ bg: 'purple.25' }}
                  bg={colorByStatus}
                  transition='background 0.2s'
                >
                  <Tooltip label={book.id} placement='top' hasArrow>
                    <Td py={2} px={3} color='gray.800'>
                      {book.title}
                    </Td>
                  </Tooltip>
                  <Td py={2} px={3} color='gray.600' fontSize='sm'>
                    {book.slug}
                  </Td>
                  <Td
                    py={2}
                    px={3}
                    color='gray.700'
                    onClick={() => {
                      setReleaseDateActive(curr => (!curr ? book.id : ''))
                    }}
                    textAlign='center'
                    cursor='pointer'
                  >
                    {releaseDateActive === book.id
                      ? ''
                      : book.releaseDate
                      ? new Date(book.releaseDate).toLocaleDateString()
                      : ''}
                    {releaseDateActive === book.id && (
                      <Flex>
                        <Input
                          type='date'
                          value={releaseDate}
                          onChange={handleReleaseDateChange}
                          autoFocus
                          onFocus={e =>
                            e.target.showPicker && e.target.showPicker()
                          }
                        />
                        <IconButton
                          icon={<Icon as={FaCheck} color='green.500' />}
                          isDisabled={!releaseDate}
                          onClick={() => {
                            setApplyData({
                              title: 'Apply release date',
                              description: `Are you sure you want to apply release date = ${releaseDate} to ${book.title}?`,
                              onApply: () => {
                                handleUpdateStory(book.id, { releaseDate })
                                setReleaseDateActive('')
                                setReleaseDate('')
                                onApplyClose()
                              },
                              onCancel: () => {
                                setReleaseDateActive('')
                                setReleaseDate('')
                                onApplyClose()
                              },
                            })
                            onApplyOpen()
                          }}
                        />
                        <IconButton
                          icon={
                            <Icon
                              as={FaTrashAlt}
                              color='red.500'
                              fontSize='16px'
                            />
                          }
                          bg='transparent'
                          onClick={e => {
                            console.log('clicked A')
                            e.stopPropagation()
                            setReleaseDateActive('')
                            setReleaseDate('')
                          }}
                        />
                      </Flex>
                    )}
                  </Td>
                  <Td py={2} px={3}>
                    <Flex
                      align='center'
                      justify='center'
                      cursor='pointer'
                      onClick={() => {
                        setApplyData({
                          title: 'Apply isReleased',
                          description: `Are you sure you want to apply isReleased = ${!book.isReleased} to ${
                            book.title
                          }?`,
                          onApply: () => {
                            handleUpdateStory(book.id, {
                              isReleased: !book.isReleased,
                            })
                            onApplyClose()
                          },
                          onCancel: () => {
                            setApplyData(null)
                            onApplyClose()
                          },
                        })
                        onApplyOpen()
                      }}
                    >
                      <Box
                        w={3}
                        h={3}
                        borderRadius='full'
                        bg={book.isReleased ? 'green.400' : 'red.300'}
                        mr={2}
                      />
                      <Box
                        color={book.isReleased ? 'green.700' : 'red.600'}
                        fontWeight='medium'
                      >
                        {book.isReleased ? 'Yes' : 'No'}
                      </Box>
                    </Flex>
                  </Td>
                  <Td
                    py={2}
                    px={3}
                    color='gray.700'
                    onClick={() => {
                      setSaleDateActive(curr => (!curr ? book.id : ''))
                    }}
                    textAlign='center'
                    cursor='pointer'
                  >
                    {saleDateActive === book.id
                      ? ''
                      : book.saleDate
                      ? new Date(book.saleDate).toLocaleDateString()
                      : ''}
                    {saleDateActive === book.id && (
                      <Flex>
                        <Input
                          type='date'
                          value={saleDate}
                          onChange={handleSaleDateChange}
                          autoFocus
                          onFocus={e =>
                            e.target.showPicker && e.target.showPicker()
                          }
                        />
                        <IconButton
                          icon={<Icon as={FaCheck} color='green.500' />}
                          isDisabled={!saleDate}
                          onClick={() => {
                            setApplyData({
                              title: 'Apply sale date',
                              description: `Are you sure you want to apply sale date = ${saleDate} to ${book.title}?`,
                              onApply: () => {
                                handleUpdateStory(book.id, { saleDate })
                                setSaleDateActive('')
                                setSaleDate('')
                                onApplyClose()
                              },
                              onCancel: () => {
                                setSaleDateActive('')
                                setSaleDate('')
                                onApplyClose()
                              },
                            })
                            onApplyOpen()
                          }}
                        />
                        <IconButton
                          icon={
                            <Icon
                              as={FaTrashAlt}
                              color='red.500'
                              fontSize='16px'
                            />
                          }
                          bg='transparent'
                          onClick={e => {
                            console.log('clicked B')
                            e.stopPropagation()
                            setSaleDateActive('')
                            setSaleDate('')
                          }}
                        />
                      </Flex>
                    )}
                  </Td>
                  <Td
                    py={2}
                    px={3}
                    color='gray.700'
                    onClick={() => {
                      setSaleValueActive(curr => (!curr ? book.id : ''))
                    }}
                    textAlign='center'
                    cursor='pointer'
                  >
                    {saleValueActive === book.id
                      ? ''
                      : book.saleValue
                      ? book.saleValue
                      : ''}
                    {saleValueActive === book.id && (
                      <Flex>
                        <Input
                          type='number'
                          value={saleValue}
                          onChange={handleSaleValueChange}
                          autoFocus
                          onFocus={e =>
                            e.target.showPicker && e.target.showPicker()
                          }
                        />
                        <IconButton
                          icon={<Icon as={FaCheck} color='green.500' />}
                          isDisabled={!saleValue}
                          onClick={() => {
                            setApplyData({
                              title: 'Apply sale value',
                              description: `Are you sure you want to apply sale value = ${saleValue} to ${book.title}?`,
                              onApply: () => {
                                handleUpdateStory(book.id, { saleValue })
                                setSaleValueActive('')
                                setSaleValue('')
                                onApplyClose()
                              },
                              onCancel: () => {
                                setSaleValueActive('')
                                setSaleValue('')
                                onApplyClose()
                              },
                            })
                            onApplyOpen()
                          }}
                        />
                        <IconButton
                          icon={
                            <Icon
                              as={FaTrashAlt}
                              color='red.500'
                              fontSize='16px'
                            />
                          }
                          bg='transparent'
                          onClick={e => {
                            e.stopPropagation()
                            setSaleValueActive('')
                            setSaleValue('')
                          }}
                        />
                      </Flex>
                    )}
                  </Td>
                  <Td py={2} px={3}>
                    <Flex
                      align='center'
                      justify='center'
                      cursor='pointer'
                      onClick={() => {
                        setApplyData({
                          title: 'Apply isHot',
                          description: `Are you sure you want to apply isHot = ${!book.isHot} to ${
                            book.title
                          }?`,
                          onApply: () => {
                            handleUpdateStory(book.id, { isHot: !book.isHot })
                            onApplyClose()
                          },
                          onCancel: () => {
                            setApplyData(null)
                            onApplyClose()
                          },
                        })
                        onApplyOpen()
                      }}
                    >
                      <Box
                        w={3}
                        h={3}
                        borderRadius='full'
                        bg={book.isHot ? 'green.400' : 'red.300'}
                        mr={2}
                      />
                      <Box
                        color={book.isHot ? 'green.700' : 'red.600'}
                        fontWeight='medium'
                      >
                        {book.isHot ? 'Yes' : 'No'}
                      </Box>
                    </Flex>
                  </Td>
                  <Td py={2} px={3}>
                    <Flex
                      align='center'
                      justify='center'
                      cursor='pointer'
                      onClick={() => {
                        setApplyData({
                          title: 'Apply isListenable',
                          description: `Are you sure you want to apply isListenable = ${!book.isListenable} to ${
                            book.title
                          }?`,
                          onApply: () => {
                            handleUpdateStory(book.id, {
                              isListenable: !book.isListenable,
                            })
                            onApplyClose()
                          },
                        })
                        onApplyOpen()
                      }}
                    >
                      <Box
                        w={3}
                        h={3}
                        borderRadius='full'
                        bg={book.isListenable ? 'green.400' : 'red.300'}
                        mr={2}
                      />
                      <Box
                        color={book.isListenable ? 'green.700' : 'red.600'}
                        fontWeight='medium'
                      >
                        {book.isListenable ? 'Yes' : 'No'}
                      </Box>
                    </Flex>
                  </Td>
                </Tr>
              )
            })}
          </Tbody>
        </Table>
      </Flex>
      {shouldShowPagination && (
        <Pagination
          changePage={changePage}
          page={page}
          total={total}
          perPage={perPage}
          shouldShowTotal
        />
      )}

      {isApplyOpen && applyData && (
        <ApplyBooleanModal
          isOpen={isApplyOpen}
          onClose={onApplyClose}
          onApply={applyData.onApply}
          onCancel={applyData.onCancel}
          title={applyData.title}
          description={applyData.description}
        />
      )}

      {isSearchOpen && (
        <SearchBookModal isOpen={isSearchOpen} onClose={onSearchClose} />
      )}
    </Flex>
  )
}

export default ReleasesAndSales
